import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box,
} from '@mui/material';

const AlertDialog = ({
  open,
  onClose,
  title,
  message,
  severity = 'info',
  confirmText = 'OK',
  cancelText,
  onConfirm,
  showCancel = false,
}) => {
  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    }
    onClose();
  };

  const getSeverityColor = (severity) => {
    switch (severity) {
      case 'error':
        return '#d32f2f';
      case 'warning':
        return '#ed6c02';
      case 'success':
        return '#2e7d32';
      case 'info':
      default:
        return '#1976d2';
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
        },
      }}
    >
      <DialogTitle>
        <Typography 
          variant="h6" 
          fontWeight={600}
          color={getSeverityColor(severity)}
        >
          {title}
        </Typography>
      </DialogTitle>
      <DialogContent dividers>
        <Typography variant="body1">
          {message}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2 }}>
        {showCancel && (
          <Button onClick={onClose} variant="outlined">
            {cancelText}
          </Button>
        )}
        <Button 
          onClick={handleConfirm} 
          variant="contained"
          sx={{
            backgroundColor: getSeverityColor(severity),
            '&:hover': {
              backgroundColor: getSeverityColor(severity),
              opacity: 0.9,
            },
          }}
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AlertDialog;
